import { useNavigate } from 'react-router-dom'

import { TimePlanningEmployeesIndexPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import PlanningVersions from 'modules/time_planning/pages/PlanningVersionsPage'

const IndexPage = () => {
  const { navigation } = useNavigation()

  const { id, planningVersionId } = useStrictParams<'id' | 'planningVersionId'>()
  const navigate = useNavigate()
  const employeeId = Number(id)

  const { data, loading } = useQuery(TimePlanningEmployeesIndexPageDocument, {
    variables: {
      employeeId: employeeId,
      planningVersionId: Number(planningVersionId),
    },
  })

  const canSeePlanningVersions =
    data?.employees.employee?._policies?.seePlanningVersions?.can ?? false
  const canEditPlanningVersions =
    data?.employees.employee?._policies?.editPlanningVersions?.can ?? false
  const canEditShifts = data?.shiftManagement._policies?.shiftCreateEverybody?.can ?? false
  const canEditContracts = data?.employees.employee?._policies?.editContract?.can ?? false
  const currentPlanningVersionId = data?.timePlanning.planningVersionsConnection.nodes[0]?.id

  useUnsafeEffect(() => {
    if (!planningVersionId) {
      navigate(
        navigation.employees.id.planningVersions.planningVersionId.fullPath({
          id,
          planningVersionId: currentPlanningVersionId ?? 0, // 0 is the default planning version
        })
      )
    }
  }, [id, planningVersionId, currentPlanningVersionId])

  if (!loading && !canSeePlanningVersions) {
    navigate(navigation.employees.id.fullPath({ id }))
  }

  if (loading) return <Loading />

  return (
    <PlanningVersions
      employeeId={employeeId}
      canSeePlanningVersions={canSeePlanningVersions}
      canEditPlanningVersions={canEditPlanningVersions}
      canEditShifts={canEditShifts}
      canEditContracts={canEditContracts}
    />
  )
}

export default IndexPage
